import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const NewsletterSection = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-teal-600 to-cyan-600">
      <div className="max-w-7xl mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
            <Sparkles className="w-4 h-4 text-white" />
            <span className="text-white text-sm font-medium">Subscribe & Save</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Get 15% Off Your First Order
          </h2>
          <p className="text-teal-100 mb-8">
            Subscribe to our newsletter for exclusive deals, health tips, and new product alerts.
          </p>

          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-5 py-3 rounded-full bg-white/10 backdrop-blur-sm border border-white/30 text-white placeholder-white/60 focus:outline-none focus:bg-white/20 transition-colors"
            />
            <button
              type="submit"
              className="flex items-center justify-center gap-2 px-6 py-3 bg-white text-teal-700 font-semibold rounded-full hover:bg-teal-50 transition-colors"
            >
              Subscribe
              <ArrowRight className="w-4 h-4" />
            </button>
          </form>

          <p className="text-teal-200 text-sm mt-4">
            No spam, unsubscribe anytime. We respect your privacy.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
